import React, { useEffect } from 'lib/react';
import { useDispatch, useSelector } from 'lib/redux';
import {
  EVGrid,
} from 'lib/components';
import { LOAD_DASHBOARD_PAGE } from 'constants/ActionTypes';
import clsx from 'clsx';
import { isSubscriptionDashboardV2EnabledSelector } from 'utils/appSelectors.utils';
import QuickLinks from './components/quickLinks/QuickLinks.component';
import DashboardStyles from './DashboardStyles';
import RecentOrders from './components/recent-orders';
import AccountsSection from './components/accountsSection/AccountsSection.component';
import SubscriptionInformation from './components/subscriptionInfo/SubscriptionInformation.component';

function Dashboard() {
  const classes = DashboardStyles();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch({ type: LOAD_DASHBOARD_PAGE });
  }, [dispatch]);

  const isSubscriptionDashboardV2Enabled = useSelector(isSubscriptionDashboardV2EnabledSelector);

  return (
    <EVGrid container className={classes.dashboardContent}>
      <EVGrid container className={clsx(classes.topContainer, isSubscriptionDashboardV2Enabled && classes.subscriptionDashboardContainer)}>
        {isSubscriptionDashboardV2Enabled ? <SubscriptionInformation /> : <AccountsSection />}
        <RecentOrders />
      </EVGrid>
      <QuickLinks />
    </EVGrid>
  );
}

export default Dashboard;
